import { MODULE_DETAILS_LIST } from "./constant"

const initialState = {
    moduleDetailsList: [],
};

const ModulesReducer = (
    state = initialState,
    action
) => {
    switch (action.type) {

        case MODULE_DETAILS_LIST:
            return {
                ...state,
                moduleDetailsList: action.payload,
            };

        default:
            return state;
    }
};

export default ModulesReducer;